var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors;
  return {
    sectionPadding: spacing.small,
    optionalLabelColor: colors.contrasts.grey4570,
    optionalLabelFontSize: typography.fontSizeXSmall,
    urlLabelMargin: spacing.xSmall
  };
};
export default generateComponentTheme;